export default __webpack_public_path__ + "static/media/livetheatermock.87c91a2c.png";